module.exports = __webpack_public_path__ + "media/images/menu_izq/afiliado-94d03fa2858ae1f9a9b1cfd3f8d614ed.svg";